export default class Card {
    constructor(data, category) {
      const {id, name, price, frontImage, frontInsideImage, backImage, favorite, type} = data 
      this.id = id;
      this.category = category;
      this.name = name;
      this.price = price;
      this.frontImage = frontImage;
      this.frontInsideImage = frontInsideImage;
      this.backImage = backImage;
      this.favorite = favorite;
      this.type = type || 1;
    }
}